import { render } from "./myleads_week.vue?vue&type=template&id=0bd07cd0&scoped=true"
import script from "./myleads_week.vue?vue&type=script&lang=js"
export * from "./myleads_week.vue?vue&type=script&lang=js"

import "./myleads_week.vue?vue&type=style&index=0&id=0bd07cd0&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\front\\syb\\syb_webchat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd07cd0"]])

export default __exports__